import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lightbox", "video"]

  toggleAccordion(event) {
    const button = event.currentTarget
    const content = button.parentElement.querySelector(".accordion-content")
    const toggle = button.querySelector(".toggle")
    if (!content) return

    const isOpen = content.classList.toggle("is-open")
    toggle.textContent = isOpen ? "−" : "+"
  }

  openLightbox(event) {
    const url = event.currentTarget.dataset.videoUrl
    if (!url) return

    this.videoTarget.src = url
    this.lightboxTarget.classList.add("is-open")
    this.videoTarget.play()
  }

  closeLightbox(event) {
    event.stopPropagation()
    this.#close()
  }

  closeLightboxOnBackground(event) {
    if (event.target === event.currentTarget) this.#close()
  }

  #close() {
    this.videoTarget.pause()
    this.videoTarget.src = ""
    this.lightboxTarget.classList.remove("is-open")
  }
}
